import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  INPUT_IMAGE_ROLE,
  MAX_IMAGE_STYLES,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.NANO_BANANA_IMAGE_EDIT_NB2_LITE,
  "provider": PROVIDER.NANO_BANANA,
  "action": IMAGE_ACTION.IMAGE_EDIT,
  "mode": IMAGE_MODE.NB2_LITE,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      // The object image first, then up to MAX_IMAGE_STYLES style references; exactly one
      // object is enforced server-side.
      "input_image": {
        "type": "array",
        "minItems": 1,
        "maxItems": 1 + MAX_IMAGE_STYLES,
        "items": {
          "type": "object",
          "properties": {
            "asset_id": { "type": "integer" },
            "role": { "type": "string", "enum": [INPUT_IMAGE_ROLE.OBJECT, INPUT_IMAGE_ROLE.STYLE] },
          },
          "required": ["asset_id", "role"],
        },
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["prompt", "input_image"],
  },
  "ui_schema": {},
}
